import { render, staticRenderFns } from "./buyGemsModal.vue?vue&type=template&id=0157d35b&scoped=true"
import script from "./buyGemsModal.vue?vue&type=script&lang=js"
export * from "./buyGemsModal.vue?vue&type=script&lang=js"
import style0 from "./buyGemsModal.vue?vue&type=style&index=0&id=0157d35b&prod&lang=scss"
import style1 from "./buyGemsModal.vue?vue&type=style&index=1&id=0157d35b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0157d35b",
  null
  
)

export default component.exports